import { render, staticRenderFns } from "./TaxesTable.vue?vue&type=template&id=807f9cde&"
import script from "./TaxesTable.vue?vue&type=script&lang=ts&"
export * from "./TaxesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports